import { useActiveConversationData } from 'hooks/useActiveConversationData'

export const useConversationTitle = () => {
  const { activeConversationData } = useActiveConversationData()

  return activeConversationData?.subject
}
